import { CognitoAuth } from 'amazon-cognito-auth-js/dist/amazon-cognito-auth'
import { CognitoRefreshToken  } from 'amazon-cognito-identity-js'

import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { config as AWSConfig } from 'aws-sdk'
import appConfig from '../config/app-config.json'
import { authenticate } from '../components/Accounts/Accounts'

AWSConfig.region = process.env.REACT_APP_COGNITO_REGION

 
// Creates a CognitoAuth instance
const createCognitoAuth = () => {
  const appWebDomain = process.env.REACT_APP_COGNITO_OAUTH.replace('https://', '').replace('http://', '')
  const auth = new CognitoAuth({
    UserPoolId: process.env.REACT_APP_COGNITO_USERPOOL,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    AppWebDomain: appWebDomain,
    TokenScopesArray: appConfig.tokenScopes,
    RedirectUriSignIn: process.env.REACT_APP_COGNITO_REDIRECT_URI_SIGN_IN,
    RedirectUriSignOut: process.env.REACT_APP_COGNITO_REDIRECT_URI_SIGN_OUT
  })
  return auth
}

// Creates a CognitoUser instance
const createCognitoUser = () => {
  const pool = createCognitoUserPool()
  return pool.getCurrentUser()
}

// Creates a CognitoUserPool instance
const createCognitoUserPool = () => new CognitoUserPool({
  UserPoolId: process.env.REACT_APP_COGNITO_USERPOOL,
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID
})

// Get the URI of the hosted sign in screen
const getCognitoSignInUri = () => {
  const signinUri = `${process.env.REACT_APP_COGNITO_OAUTH}/login?response_type=code&client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT_URI_SIGN_IN}`
  return signinUri
}

// Parse the response from a Cognito callback URI (assumed a token or code is in the supplied href). Returns a promise.
const parseCognitoWebResponse = (href) => {
  return new Promise((resolve, reject) => {
    const auth = createCognitoAuth()

    // userHandler will trigger the promise
    auth.userhandler = {
      onSuccess: function (result) {
        resolve(result)
      },
      onFailure: function (err) {
        reject(new Error('Failure parsing Cognito web response: ' + err))
      }
    }
    auth.parseCognitoWebResponse(href)
  })
}

// Gets a new Cognito session. Returns a promise.
const getCognitoSession = () => {
  return new Promise((resolve, reject) => {
    const cognitoUser = createCognitoUser()
    cognitoUser.getSession((err, result) => {
      if (err || !result) {
        reject(new Error('Failure getting Cognito session: ' + err))
        return
      }
      // Resolve the promise with the session credentials
      //console.debug('Successfully got session: ' + JSON.stringify(result))
      authenticate(result);
      const session = {
        credentials: {
          accessToken: result.accessToken.jwtToken,
          idToken: result.idToken.jwtToken,
          refreshToken: result.refreshToken.token
        },
        user: {
          userName: result.idToken.payload['cognito:username'],
          email: result.idToken.payload.email
        }
      }
      resolve(session)
    })
  })
}

// Sign out of the current session (will redirect to signout URI)
const signOutCognitoSession = () => {
  const auth = createCognitoAuth()
  auth.signOut()
}
const refreshSession = () => (dispatch, getState) => {
  let cognitoUser = createCognitoUser();
  let sessionData = getState().security.session;
  let refreshToken = new CognitoRefreshToken({ RefreshToken: sessionData.refreshToken.token });

  return new Promise((resolve, reject) => {
      cognitoUser.refreshSession(refreshToken, function(err, result) {
          if (err) {
              reject(err);
          }
          else {
              resolve(result);
          }
      });
  });
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  createCognitoAuth,
  createCognitoUser,
  createCognitoUserPool,
  getCognitoSession,
  getCognitoSignInUri,
  parseCognitoWebResponse,
  signOutCognitoSession,
  refreshSession
}